import React, { type JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCurrentUser } from '@features/auth';
import { getUserTypes } from '@features/auth/utils/getUserTypes';
import { privateRoutes, publicRoutes, userType } from '@constants';
import { Button } from '@core-ui/Components/ui/button';
import { Tendril404Typed } from '@assets/index';

export default function NotFoundPage (): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const currentUser = getCurrentUser();

  const handleRedirect = (): void => {
    if (currentUser == null) {
      navigate(publicRoutes.LOGIN, { replace: true });
      return;
    }

    const types = getUserTypes(currentUser);
    if (types.includes(userType.ADMIN) || types.includes(userType.SDR)) {
      navigate(privateRoutes.WIZARD, { replace: true });
    } else if (types.includes(userType.AGENT)) {
      navigate(privateRoutes.AGENT, { replace: true });
    }
  };

  return (
    <div className="min-h-[100dvh] flex flex-col items-center justify-center px-6 text-center bg-background text-foreground transition-colors">
      <div className="max-w-lg flex flex-col items-center space-y-6">
        <img
          src={Tendril404Typed}
          alt="404 not found"
          className="w-72 h-auto invert dark:invert-0"
        />

        <h1 className="text-4xl font-bold text-primary dark:text-white">
          Oops! Page not found
        </h1>

        <p className="text-muted-foreground text-sm">
          We can’t find the page you’re looking for. It might have been removed
          or relocated.
        </p>

        <Button
          data-qa-id="back-to-home"
          onClick={handleRedirect}
          className="cursor-pointer bg-primary text-primary-foreground hover:bg-primary/90"
        >
          {currentUser != null ? t('notFound.back') : t('notFound.backToLogin')}
        </Button>
      </div>
    </div>
  );
}
